import { ComponentType, Fragment, createElement } from 'react'
import AutoField from './AutoField'
import { useCiboAutoForm } from './CiboAutoFormContext'

export type AutoFieldsProps = {
  element?: ComponentType | string
  fields?: string[]
  omitFields?: string[]
  showInlineError?: boolean
}

export const AutoFields = ({
  element = Fragment,
  fields,
  omitFields = [],
  showInlineError,
  ...props
}: AutoFieldsProps) => {
  const form = useCiboAutoForm()

  const schema = form.schema

  return createElement(
    element,
    props,
    (fields ?? schema.getSubfields())
      .filter(field => !omitFields.includes(field))
      .map(field => {
        return createElement(
          AutoField,
          Object.assign(
            { key: field, name: field, warning: form.warnings?.[field] },
            showInlineError === undefined ? null : { showInlineError }
          )
        )
      })
  )
}
